
(function () {
  function featuredBlogSlider(root = document) {
    if (typeof Swiper === 'undefined') return;

    const sliders = [];

    if (root.matches && root.matches('.blog-slider')) {
      sliders.push(root);
    }

    if (root.querySelectorAll) {
      sliders.push(...root.querySelectorAll('.blog-slider'));
    }

    sliders.forEach((slider) => {
      // Prevent duplicate Swiper initialization
      if (slider.swiper && !slider.swiper.destroyed) {
        return;
      }

      const id = slider.dataset.id;
      const sliderLoopTrue = slider.dataset.loop === 'true';

      new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: `#shopify-section-${id} .slider-arrow-next`,
          prevEl: `#shopify-section-${id} .slider-arrow-prev`
        },
        breakpoints: {
          750: {
            loop: sliderLoopTrue,
            slidesPerView: 2
          },
          990: {
            loop: sliderLoopTrue,
            slidesPerView: 'auto'
          },
          1199: {
            loop: sliderLoopTrue,
            slidesPerView: 'auto',
            spaceBetween: 30
          }
        }
      });
    });
  }

  // Initialize once when the page loads
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        featuredBlogSlider();
      },
      { once: true }
    );
  } else {
    featuredBlogSlider();
  }

  // Initialize new sections in the Shopify editor
  document.addEventListener('shopify:section:load', function (event) {
    featuredBlogSlider(event.target);
  });

  // Clean up removed sections
  document.addEventListener('shopify:section:unload', function (event) {
    const sliders = event.target.querySelectorAll('.blog-slider');

    sliders.forEach((slider) => {
      if (slider.swiper && !slider.swiper.destroyed) {
        slider.swiper.destroy(true, true);
      }
    });
  });
})();
